import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Form, Formik } from 'formik';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Tabs, Tab, Box } from '@material-ui/core';
import _e from 'common/localeUtil';
import {
	addWidgetDisclaimerSlateHtmlText,
	getDefaultContactDisclaimer,
	MESSAGE_TYPES,
	setContactDisclaimerGrapesJS,
} from '../../utils';
import { a11yProps, TabPanel } from '../tab/tab';
import GenericDialog from './GenericDialog';
import GMButton from '../button/GMButton';
import ContactDisclaimerForm from '../form/ContactDisclaimerForm';
import WidgetDisclaimerForm from '../form/WidgetDisclaimerForm';
import { WIDGET_DISCLAIMER_DEFAULT } from '../../constants';

const useStyles = makeStyles(() => ({}));

const EditDisclaimersDialog = (props) => {
	const { open, handleClose } = props;
	const classes = useStyles();
	const showMessage = useStoreActions((actions) => actions.showMessage.showMessage);
	const [selectedTab, setSelectedTab] = useState(0);
	const [errorMessage, setErrorMessage] = useState(null);
	const saveOtherSettings = useStoreActions((actions) => actions.template.saveOtherSettings);
	const otherSettings = useStoreState((state) => state.template.otherSettings);
	const adviserData = useStoreState((state) => state.template.adviserData);

	const { widget_disclaimer = WIDGET_DISCLAIMER_DEFAULT } = otherSettings;
	let contact_disclaimer = otherSettings?.contact_disclaimer;
	contact_disclaimer = getDefaultContactDisclaimer({ contact_disclaimer, adviserData });

	const handleChange = (event, newValue) => {
		setSelectedTab(newValue);
	};

	useEffect(() => {
		// console.log('ContactSettings useEffect', contactForm);
		// setContactFormToTemplate(contactForm);
	});

	const onSubmit = async (values, { setSubmitting }) => {
		console.log('EditDisclaimersDialog onSubmit', values);
		const finalValues = addWidgetDisclaimerSlateHtmlText(values);
		const responseData = await saveOtherSettings(finalValues);
		if (responseData?.success) {
			showMessage({ text: _e('settings_updated'), type: MESSAGE_TYPES.SUCCESS });
			handleClose();
			//	also change disclaimers in HTML
			const { contact_disclaimer } = finalValues;
			setContactDisclaimerGrapesJS(contact_disclaimer);
		} else {
			setErrorMessage(responseData?.data?.error || 'Error');
		}
		setSubmitting(false);
	};

	const renderForm = (formikBag) => {
		const { isValid, isSubmitting, setFieldValue } = formikBag;
		return (
			<Form className={classes.formWrapper}>
				<div className={classes.tabs}>
					<Tabs
						value={selectedTab}
						onChange={handleChange}
						indicatorColor="primary"
						textColor="primary"
						variant="scrollable"
						scrollButtons="auto"
						aria-label="disclaimers"
					>
						<Tab label={_e('contact_form_disclaimer')} {...a11yProps(0)} />
						<Tab label={_e('widget_disclaimer')} {...a11yProps(1)} />
					</Tabs>
					<TabPanel value={selectedTab} index={0}>
						<ContactDisclaimerForm
							errorMessage={errorMessage}
							setFieldValue={setFieldValue}
						/>
					</TabPanel>
					<TabPanel value={selectedTab} index={1}>
						<WidgetDisclaimerForm
							errorMessage={errorMessage}
							setFieldValue={setFieldValue}
						/>
					</TabPanel>
				</div>
				<Box
					p={1}
					justifyContent="flex-end"
					alignItems="center"
					flexDirection="row"
					display="flex"
				>
					<GMButton
						variant="contained"
						type="submit"
						disabled={!isValid}
						title={_e('save')}
						color="primary"
						loading={isSubmitting}
					/>
				</Box>
			</Form>
		);
	};

	const initialValues = {
		contact_disclaimer,
		widget_disclaimer,
	};

	const renderFormikContent = () => {
		return (
			<div>
				<Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize>
					{renderForm}
				</Formik>
			</div>
		);
	};

	return (
		<GenericDialog
			maxWidth="sm"
			fullWidth
			title={_e('disclaimer_settings')}
			// subtitle={<span>Create your own personal branding ebook.</span>}
			content={renderFormikContent()}
			showTitleDivider
			handleClose={handleClose}
			open={open}
			hideConfirmButton
		/>
	);
};

EditDisclaimersDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func,
	from: PropTypes.string,
	sectionId: PropTypes.string,
};

export default EditDisclaimersDialog;
